const texts = {
  title: 'Some onboarding steps are still pending. Click here to finish setting up',
};

export default texts;
